import { usePages } from './use-pages';
import { useSubTopics } from './use-sub-topics';
import { useTopics } from './use-topics';
import { useTrends } from "./use-trends";
import { keyBy } from 'lodash';
import { useMemo } from "react";
export var useEntityDictionary = function useEntityDictionary(by) {
  if (by === void 0) {
    by = 'slug';
  }

  var trends = useTrends();
  var topics = useTopics();
  var subTopics = useSubTopics();
  var pages = usePages();
  return useMemo(function () {
    return {
      Topic: keyBy(topics, by),
      Trend: keyBy(trends, by),
      SubTopic: keyBy(subTopics, by),
      Page: keyBy(pages, by)
    };
  }, [trends, topics, subTopics, pages, by]);
};